module.exports = __webpack_public_path__ + "img/drop.5ba73ae0.svg";